import { getHandleResponse } from "helpers/getHandleResponse";
import { getAuthHeader } from "helpers/getAuthHeader";

const API_BASE_URL = process.env.REACT_APP_URL;

const makeRequest = async (endpoint, method, data = null) => {
    const requestOptions = {
        method,
        headers: getAuthHeader(),
    };

    if (data) {
        requestOptions.body = JSON.stringify(data);
    }

    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, requestOptions);
        const result = await getHandleResponse(response);
        return { error: false, data: result };
    } catch (error) {
        return { error: true, data: error.message };
    }
};

const buildQueryString = (params) => {
    const filteredParams = Object.entries(params)
        .filter(([_, value]) => value !== null && value !== undefined && value !== '')
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

    return new URLSearchParams(filteredParams).toString();
};

const downloadReport = async (endpoint, filename) => {
    const requestOptions = {
        method: 'GET',
        headers: getAuthHeader(),
    };

    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, requestOptions);

        if (!response.ok) {
            throw new Error('Error al descargar reporte');
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);

        return { error: false, data: 'Reporte descargado' };
    } catch (error) {
        return { error: true, data: error.message };
    }
};

const reportService = {
    // Generar reporte de facturas
    generateInvoiceReport: (params = {}) => {
        const queryString = buildQueryString(params);
        return makeRequest(`/api/reports/invoices${queryString ? `?${queryString}` : ''}`, "GET");
    },

    // Descargar reporte de facturas en Excel
    downloadInvoiceReportExcel: (params = {}) => {
        const queryString = buildQueryString({ ...params, format: 'excel' });
        return downloadReport(
            `/api/reports/invoices${queryString ? `?${queryString}` : ''}`,
            `reporte_facturas_${new Date().toISOString().split('T')[0]}.xlsx`
        );
    },

    // Descargar reporte de facturas en PDF
    downloadInvoiceReportPDF: (params = {}) => {
        const queryString = buildQueryString({ ...params, format: 'pdf' });
        return downloadReport(
            `/api/reports/invoices${queryString ? `?${queryString}` : ''}`,
            `reporte_facturas_${new Date().toISOString().split('T')[0]}.pdf`
        );
    },

    // Reporte por centro de costo
    generateCostCenterReport: (params = {}) => {
        const queryString = buildQueryString(params);
        return makeRequest(`/api/reports/cost-centers${queryString ? `?${queryString}` : ''}`, "GET");
    },

    // Reporte por tipo de gasto
    generateExpenseTypeReport: (params = {}) => {
        const queryString = buildQueryString(params);
        return makeRequest(`/api/reports/expense-types${queryString ? `?${queryString}` : ''}`, "GET");
    },
};

export default reportService;